import React from 'react';
import './assets/styles/loading-styles.scss';
import apptitude_logo from '../../assets/images/apptitude-logo.svg';

function Loading({ isLoadingOnPage = false }) {
  const styles = isLoadingOnPage
    ? {
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '100vh',
        width: '100vw',
        backgroundColor: 'rgba(255,255,255,0.3)',
      }
    : { display: 'none' };
  return (
    <div id="apptitude-loading" style={styles}>
      <img src={apptitude_logo} alt="Apptitude" />
    </div>
  );
}

export default Loading;
